import * as React from "react";
import PropTypes from "prop-types";
import InputField from "./InputField";

export default class GenericField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["text", "password", "email", "number", "tel"])
      .isRequired,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    maxLength: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func,
    error: PropTypes.string,
  };

  state = {
    value: this._extractStateValue(this.props),
    hasLeftLabel: false,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({ value: this._extractStateValue(nextProps) });
    }
  }

  _extractStateValue(props) {
    return props.value || "";
  }

  _handleChange = (event) => {
    const { value } = event.currentTarget;
    this.setState({ value });

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    const { value } = this.state;
    return (
      <InputField {...this.props} value={value} onChange={this._handleChange} />
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/GenericField.jsx